import React, { Component, PropTypes } from 'react';
import scriptLoader from 'react-async-script-loader';
import WistiaPlayer from './WistiaPlayer';

class WistiaPlayerWrapper extends Component {
    static propTypes = {
        onLoaded: PropTypes.func,
        onError: PropTypes.func,
        errorContent: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    }

    componentWillReceiveProps({ isScriptLoaded, isScriptLoadSucceed }) {
        if (isScriptLoaded && !this.props.isScriptLoaded) {
            if (isScriptLoadSucceed) {
                window._wq = window._wq || [];

                if (this.props.onLoaded) {
                    this.props.onLoaded();
                }
            } else if(this.props.onError) {
                this.props.onError();
            }
        }
    }
    
    render() {
        const { isScriptLoaded, isScriptLoadSucceed, errorContent } = this.props;

        return (
            isScriptLoaded
                ? isScriptLoadSucceed
                    ? <WistiaPlayer wq={window._wq} {...this.props} />
                    : errorContent
                : <div className={this.props.notLoadedClassName}>{ this.props.children }</div>
        )
    }
}

export default scriptLoader(['//fast.wistia.com/assets/external/E-v1.js'])(WistiaPlayerWrapper);


// WEBPACK FOOTER //
// ./src/WistiaPlayerWrapper.jsx